import Image from "next/image";

export default function BrandCloud() {
  return (
    <div className="mx-auto mt-5 grid max-w-7xl grid-cols-3 md:grid-cols-4 lg:grid-cols-5 items-center justify-items-center gap-x-6 gap-y-8 sm:gap-x-12 sm:gap-y-8">
      <Image className="h-9 w-auto object-contain max-w-full" src="/brands/monks.svg" alt="Monks media Logo" height={20} width={100} />
      <Image
        className="h-12 w-auto object-contain max-w-full"
        src="/brands/independer.png"
        alt="Independer Logo"
        quality={100}
        height={500}
        width={700}
      />
      <Image className="h-10 w-auto object-contain max-w-full" src="/brands/adwise.png" alt="Adwise Logo" height={20} width={100} />
      <Image className="h-7 w-auto object-contain max-w-full" src="/brands/crisp.svg" alt="Nvidia Logo" height={20} width={100} />
      <Image
        className="h-10 w-auto object-contain max-w-full"
        src="/brands/creativeforce.png"
        alt="Creativeforce Logo"
        height={20}
        width={100}
      />
      <Image className="h-10 w-auto object-contain max-w-full" src="/brands/dpg.svg" alt=" media Logo" height={200} width={100} />
      <Image
        className="h-7 opacity-90 w-auto object-contain max-w-full"
        src="/brands/polymarket.svg"
        alt="Polymarket Logo"
        height={20}
        width={120}
      />
      <Image
        className="h-8 w-auto object-contain max-w-full"
        src="/brands/simpleanalytics.png"
        alt="Simple Analytics Logo"
        quality={100}
        height={400}
        width={500}
      />
      <Image className="h-7 w-auto object-contain max-w-full" src="/brands/weglot.svg" alt="Weglot Logo" height={20} width={100} />
      <Image
        className="h-5 w-auto object-contain max-w-full"
        src="/brands/centerparcs-new.png"
        alt="Center Parcs Logo"
        height={400}
        quality={100}
        width={500}
      />
      <Image
        className="h-6 w-auto object-contain max-w-full"
        src="/brands/brunel.png"
        alt="Brunel Logo"
        quality={100}
        height={400}
        width={500}
      />
      <Image
        className="h-10 w-auto object-contain max-w-full"
        src="/brands/erasmus.png"
        alt="Erasmus Logo"
        quality={100}
        height={400}
        width={500}
      />

      <Image
        className="h-7 w-auto object-contain max-w-full"
        src="/brands/opascope.svg"
        alt="Opascope Logo"
        quality={100}
        height={400}
        width={500}
      />
      <Image
        className="h-10 w-auto object-contain max-w-full"
        src="/brands/bowtie.png"
        alt="Bowtie Logo"
        quality={100}
        height={400}
        width={500}
      />
      <Image
        className="h-7 w-auto object-contain max-w-full"
        src="/brands/goochem.png"
        alt="Goochem Logo"
        quality={100}
        height={400}
        width={500}
      />
    </div>
  );
}
